import { makeStyles } from '@material-ui/core/styles';
import { formFieldStyles } from '../../shared/styles/formField.styles';

export const useProfileEditSharedStyles = makeStyles(() => ({
  field: {
    ...formFieldStyles.field,
  },
  label: {
    ...formFieldStyles.label,
  },
  input: {
    ...formFieldStyles.input,
  },
  errorField: {
    ...formFieldStyles.errorField,
  },
  phoneField: {
    ...formFieldStyles.phoneField,
  },
}));
